import { DivisionLayout } from '../components/layout/DivisionLayout';

const divisionData = {
  divisionName: 'Overlay Systems',
  accentColor: '#2ecc71',
  heroImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/6qke7haj_image.png',
  aboutText: [
    {
      text: '<strong>Catworth Overlay Systems</strong> specializes in wear protection solutions using <strong>Duroxite® wear plate and hard facing materials supplied by SSAB South Africa</strong>. Our focus is the processing, fabrication, and application of high-performance overlay materials designed for extreme wear environments commonly found in mining, cement, and heavy industry.'
    },
    {
      text: 'Using both <strong>CNC-controlled and manually applied hard facing processes</strong>, Catworth applies Duroxite® welding wire to protect and rebuild critical components such as crushers, hammers, and vertical mill wear parts. Combined with our fabrication capabilities, we deliver durable wear solutions that extend component life, reduce maintenance cycles, and improve equipment reliability.'
    }
  ],
  aboutImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/qhxeeb6a_image.png',
  aboutImagePosition: 'center bottom',
  galleryImages: [
    'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/1v13hro6_image.png',
    'https://images.unsplash.com/photo-1697281679290-ad7be1b10682?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1575305842946-0e807ce6f3fc?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  capabilities: [
    { title: 'Duroxite® Wear Plate Fabrication', description: 'Processing and fabrication of SSAB Duroxite® overlay wear plates used in high-abrasion industrial applications.' },
    { title: 'Hard facing and Overlay Welding', description: 'Application of wear-resistant overlay welding using Duroxite® welding consumables to protect or rebuild critical components.' },
    { title: 'CNC Overlay Welding', description: 'Precision automated hard facing for consistent wear protection across large surfaces and complex components.' },
    { title: 'Manual Hard facing Applications', description: 'Specialized manual welding processes for targeted repairs and custom wear protection solutions.' },
    { title: 'Crusher and Hammer Refurbishment', description: 'Rebuilding and wear protection of crusher components, hammers, and impact surfaces.' },
    { title: 'Vertical Mill Wear Components', description: 'Hard facing of vertical grinding mill components including rollers, tables, and wear segments.' },
    { title: 'High-Wear Industrial Fabrications', description: 'Manufacture and refurbishment of fabricated components designed to operate in severe abrasive environments.' },
  ],
  partnerLogo: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/iavep7kk_DUROXITE.svg',
  partnerLogoUrl: 'https://www.ssab.com/en/brands-and-products/duroxite/download?gad_source=1&gad_campaignid=16679229096&gbraid=0AAAAABcd3g2lrP9SntGozXwriuDAUlkB1&gclid=Cj0KCQjw7IjOBhDyARIsAFzrWQyC-SfJe8KPl2YDz4LEGSsHZJhQIBYhcsJ9M2k7bI9nDdS292lE2lEaAiaEEALw_wcB',
};

export const OverlaySystems = () => {
  return <DivisionLayout {...divisionData} />;
};

export default OverlaySystems;
